import cookies from './cookie';

export const CHANNEL_RESOURCE_CODE = 'channelResourceCode';

export function getChannelResourceCode() {
  return cookies.get(CHANNEL_RESOURCE_CODE) || '';
}

/**
 * 存储渠道资源位
 *
 * @param channelResourceCode {String}
 * @param expire {Number?} 过期时间
 */
export function setChannelResourceCode(channelResourceCode: string, expire = 60 * 24 * 9999) {
  return cookies.set(CHANNEL_RESOURCE_CODE, channelResourceCode, expire);
}

export function removeChannelResourceCode() {
  return cookies.remove(CHANNEL_RESOURCE_CODE);
}


// 处理用户是否为黑名单逻辑
export const getIsBlackUser = () => {
  const userBlackFlag = cookies.get('userBlackFlag');
  return userBlackFlag === '1' ? true : false;
};

export const setIsBlackUser = (userBlackFlag = false) => cookies.set('userBlackFlag', userBlackFlag ? '1' : '0', 90);
